import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";

import { Analytics } from "@vercel/analytics/react";

import "./styles/App.css";
import { AuthProvider } from "./contexts/AuthContext.jsx";
import CanvasComponent from "./components/features/canvas/Canvas.jsx";
import { BillingCleanup } from "./components/features/settings";
import Landing from "./pages/Landing.jsx";
import ProfilePage from "./pages/ProfilePage.jsx";
import PrivacyPage from "./pages/PrivacyPage.jsx";
import TermsPage from "./pages/TermsPage.jsx";

function App() {
  return (
    <>
      <Analytics />
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/payments" element={<BillingCleanup />} />
            <Route path="/app/*" element={<CanvasComponent />} />
          </Routes>
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;
